import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { changePreferredOptions } from '../../store/itineraryOptions/itineraryOptions.actions'
import { selectPreferredSpeed, selectVehicleOwn } from '../../store/itineraryOptions/itineraryOptions.selectors'
import T, { useTranslateAsObject } from '../i18n/T'
import { useAction } from '../utils/react-redux'
import { PREFERRED_SPEED, TRAVEL_SPEED_VALUES_BY_MODE, TRAVEL_SPEEDS, VEHICLE_OWN } from './ItineraryOptions.constants'
import s from './ModeSpeedSettingsBox.less'
import VehicleOwnedSwitcher from './VehicleOwnedSwitcher'

const speedTKey = item => `itinerary.options.speed.${item}`

export default function ModeSpeedSettingsBox({ modeId, hasOwnSwitcher }) {
  const preferredSpeed = useSelector(selectPreferredSpeed(modeId))
  const vehicleOwn = useSelector(selectVehicleOwn(modeId))
  const execChangePreferredOptions = useAction(changePreferredOptions)
  const translations = useTranslateAsObject(TRAVEL_SPEEDS.map(speedTKey))

  const onPreferredOptionsChange = useCallback(event => {
    const value = event.target.value
    execChangePreferredOptions({
      modeId,
      [PREFERRED_SPEED]: value
    })
  }, [])

  return (
    <div>
      {hasOwnSwitcher && (
        <div>
          <VehicleOwnedSwitcher
            labelKey={`itinerary.options.own.${modeId}`}
            onChange={value =>
              execChangePreferredOptions({
                modeId,
                [VEHICLE_OWN]: value
              })
            }
            defaultValue={vehicleOwn}
          />
        </div>
      )}
      <div className={s.speedWrapper}>
        <T id={speedTKey('generic')} />
        <select onChange={onPreferredOptionsChange} value={preferredSpeed}>
          {TRAVEL_SPEEDS.map(value => (
            <option key={`${modeId}_${value}`} value={value}>
              {translations[speedTKey(value)]} ({TRAVEL_SPEED_VALUES_BY_MODE[modeId][value]} km/h)
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}
